import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-document-v2",
  "use": "icon-document-v2-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-document-v2\"><path d=\"M5 4h4.586c.265 0 .52.105.707.293L12 6h7a1 1 0 0 1 1 1v2H4V5a1 1 0 0 1 1-1zm-1.753 7h17.506a1 1 0 0 1 .977 1.217l-1.556 7a1 1 0 0 1-.976.783H4.802a1 1 0 0 1-.976-.783l-1.556-7A1 1 0 0 1 3.247 11z\" fill=\"#A4B4D0\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol